export default __webpack_public_path__ + "5c0814b1c54e5ee68a78bcafa3b37461.png";